/**
 * Ajout d'un événement à l'agenda personnel du membre.
 *
 * Deux chemins, parce qu'aucun ne couvre tout le monde :
 *  - **fichier .ics** : le format standard, compris par Apple Calendrier,
 *    Outlook, Thunderbird et Android. Généré localement, donc utilisable
 *    hors ligne — la PWA n'a rien à demander au serveur.
 *  - **lien Google Agenda** : Google n'importe un .ics qu'au prix d'un détour
 *    par Drive ; le lien direct est bien plus simple pour l'utilisateur.
 */

/** Date UTC au format iCalendar : 20260918T163000Z. */
function horodatage(iso) {
  const d = new Date(iso);
  if (isNaN(d)) return '';
  return d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
}

/**
 * Échappement iCalendar (RFC 5545) : la virgule, le point-virgule et la barre
 * oblique inverse sont des séparateurs, et un saut de ligne casserait le
 * fichier. Les titres d'activités du club en contiennent (« Championnats
 * suisses « Parcours » — bénévoles, samedi »).
 */
function echapper(texte) {
  return String(texte || '')
    .replace(/\\/g, '\\\\')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,')
    .replace(/\r?\n/g, '\\n');
}

/** Deux heures par défaut si l'activité n'a pas de fin renseignée. */
function fin(evenement) {
  if (evenement.fin) return evenement.fin;
  const d = new Date(evenement.debut);
  return isNaN(d) ? evenement.debut : new Date(d.getTime() + 2 * 3600000).toISOString();
}

/** Contenu d'un fichier .ics pour un événement. */
export function versIcs(evenement) {
  // Les lignes d'un fichier iCalendar se terminent par CRLF.
  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Archers de la Tour//PWA//FR',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:adlt-${evenement.id || Date.now()}@archersdelatour`,
    `DTSTAMP:${horodatage(new Date().toISOString())}`,
    `DTSTART:${horodatage(evenement.debut)}`,
    `DTEND:${horodatage(fin(evenement))}`,
    `SUMMARY:${echapper(evenement.titre)}`,
    evenement.lieu ? `LOCATION:${echapper(evenement.lieu)}` : '',
    evenement.description ? `DESCRIPTION:${echapper(evenement.description)}` : '',
    'END:VEVENT',
    'END:VCALENDAR',
  ].filter(Boolean).join('\r\n');
}

/** Télécharge l'événement en .ics (Apple, Outlook, Thunderbird, Android). */
export function telechargerIcs(evenement) {
  const blob = new Blob([versIcs(evenement)], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = (evenement.titre || 'evenement').replace(/[^\w-]+/g, '-').slice(0, 60) + '.ics';
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Laisser au navigateur le temps d'amorcer le téléchargement.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Lien d'ajout à Google Agenda. */
export function lienGoogle(evenement) {
  const p = new URLSearchParams({
    action: 'TEMPLATE',
    text: evenement.titre || '',
    dates: `${horodatage(evenement.debut)}/${horodatage(fin(evenement))}`,
  });
  if (evenement.lieu) p.set('location', evenement.lieu);
  if (evenement.description) p.set('details', evenement.description);
  return 'https://calendar.google.com/calendar/render?' + p.toString();
}
